import thunk from 'redux-thunk';
import reduxCatch from 'redux-catch';
import catchReduxError from 'src/js/modules/error/helpers/catch-redux-error';
import webappPlugins from './modules/webapp-plugins';
import featureFlags from './modules/feature-flags';
import analytics from './modules/analytics';
import products from './modules/products';
import error from './modules/error';
import checkoutServiceClient from './modules/checkoutservice-client';
import publishingServiceClient from './modules/publishing-service-client';
import yowsServiceClient from './modules/yows-service-client';
import helpCenter from './modules/help-center';

export default [
  thunk,
  reduxCatch(catchReduxError),
  error.middleware.errorHandler,
  webappPlugins.middleware.configuration,
  featureFlags.middleware.clientLoader,
  products.middleware.clientLoader,
  checkoutServiceClient.middleware.clientLoader,
  publishingServiceClient.middleware.clientLoader,
  yowsServiceClient.middleware.clientLoader,
  analytics.segment.middleware.segmentInitializer,
  helpCenter.middleware.initHelpCenter,
];
